import React, { useEffect, useState } from "react";
import PrivateApi from "../../../services/PrivateApiService";
import { Badge, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { HiXMark } from "react-icons/hi2";
import { FaCheck } from "react-icons/fa";

/**
 * 
 * ELV Stage
 * 
 * @param {state} props list of last data collection from backend
 * @param {setState} props setter will be set at data collecting from backedn to avoid multiple collection of same data
 * @param {setSelectedElvs} props object setter for passing selected elvs to main component
 * @param {setStage} props string setter for changing stage
 * @param {building} props object selected building
 * @param {error} props string setter for displaying error messages
 * 
 * @returns 
 */
const ElvTicketStage = (props) => {

    // * core variables
    const API = new PrivateApi(); // API
    const [elvs, setElvs] = useState(props.state); // elvs data from backend
    const [filteredElvs, setFilteredElvs] = useState(props.state); // used to display and filter elvs
    const [selectedElvs, setSelectedElvs] = useState(null); // selected elvs
    const [elvsLoading, setElvsLoading] = useState(false); // by api call true
    const [selectedElvsHover, setSelectedElvsHover] = useState(false); // when mouse enters selected elv badge
    const elvsTableColumns = [
        {
            name: "Nummer", 
            selector: row => row.id,

        },
        {
            name: "Anlagennummer Lieferant", 
            selector: row => row.x_anlagennummer_lieferant === "False" ? "nicht erfasst": row.x_anlagennummer_lieferant, 
            sortable: true,
            grow: 1.5,
        },
        {
            name: "Energieform", 
            selector: row => row.x_anlage_id[1].split('_')[1], 
            sortable: true},
        {
            name: "Belieferung", 
            selector: row => `${row.x_belbeg === "False"? 'TBA' : new Date(row.x_belbeg).toLocaleDateString('DE-de')} - ${row.x_datum_vertragsende === "False"? 'offenes Vertragsende': new Date(row.x_datum_vertragsende).toLocaleDateString('DE-de')}`,
            
        },
        {
            name: "Leerstand", 
            selector: row => row.x_is_leerstand ? <FaCheck className="text-energo" /> : <HiXMark className="text-danger"/>,
            center: true
        }
    ]

    const paginationOptions = {
        rowsPerPageText: 'Zeilen pro Seite',
        rangeSeparatorText: 'von',
        selectAllRowsItemText: 'Alle'
    }

    // * filter fields
    const [elvSearchField, setElvsSearchField] = useState(""); // search field
    const [elvActiveCheck, setElvActiveCheck] = useState(false); // active checkbox
    const [elvLeerstandCheck, setElvLeerstandCheck] = useState(false); // leerstand checkbox



    // * effects
    // onload effect to geather Elvs from backend
    useEffect(() => {
        if (props.building === true) {
            props.setStage("body");
        }
        setSelectedElvs(null);

        // only if data are not loaded and different building was selected
        if (props.state === undefined || props.state.length === 0 || props.state[0].x_kunde_id[0] !== props.building.id) {
            setElvsLoading(true);
            API.get_ElvsBuilding(props.building.id)
                .then(res => {
                    let data = res.data;
                    setElvs(data.elvs);
                    setFilteredElvs(data.elvs);
                    setElvsLoading(false);
                    props.setState(data.elvs);
                })
                .catch(err => {
                    setElvsLoading(false);
                    if (err.response.data.detail !== undefined) {
                        props.error(err.response.data.detail);
                        return props.setStage("error");
                    }
                    props.error("Unbekannter Fehler.");
                    return props.setStage("error");
                })
        }
    }, [])

    // on fields change effect
    useEffect(() => {
        filterHandler();
    }, [elvSearchField, elvActiveCheck, elvLeerstandCheck])

    // effect when "Energieliefervertrag ist nicht relevant" is selected
    useEffect(() => {
        if (selectedElvs === true) {
            var tableRowsSelected = document.getElementsByClassName('bg-energo');
            if (tableRowsSelected.length > 0) {
                for (let i=0; i <= tableRowsSelected.length; i++) {
                    tableRowsSelected[i].classList.remove('bg-energo');
                }
            }
        }
    }, [selectedElvs])



    // * handlers
    // filter handler
    const filterHandler = () => {
        var tempList = [...elvs];

        if (elvActiveCheck) {
            tempList = tempList.filter(e => new Date(e.x_datum_vertragsende) > new Date());
        }
        if (elvLeerstandCheck) {
            tempList = tempList.filter(e => e.x_is_leerstand === true);
        }
        if (elvSearchField.length > 3) {
            tempList = tempList.filter(e => e.x_anlagennummer_lieferant.includes(elvSearchField));
        }
        setFilteredElvs(tempList);
    }

    // style datatable on select
    const conditionalRowStyles = [
        {
            when: row => selectedElvs && selectedElvs.includes(row),
            style: {
                background: '#a2c13f',
                userSelect: "none",
            }
        }
    ]

    // table row clicked handler
    const rowClickedHandler = (row) => {
        if (selectedElvs && selectedElvs.length > 0) {
            var index = selectedElvs.findIndex(i => i === row);
            if (index === -1) setSelectedElvs(prev => [...prev, row]);
            else setSelectedElvs(selectedElvs.filter(f => f !== row));
        } 
        else {
            setSelectedElvs([row]);
        }
    }

    // remove selected ELV handler
    const removeSelectedElvHandler = (elv_id) => {
        var index = selectedElvs.findIndex(i => i.id === elv_id);
        if (index > -1) {
            var tempList = selectedElvs.filter(e => e.id !== elv_id);
            setSelectedElvs(tempList);
            document.getElementById(`row-${elv_id}`).classList.remove("bg-energo");
            setSelectedElvsHover(false);
        }
    }

    // GUI
    return (
        <>
            {
                elvsLoading ?
                    <Row className="mt-5 text-center">
                        <p>Ihre Energielieferverträge werden gesammelt...</p>
                        <Col xs="12">
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                        </Col>
                    </Row>
                :
                    <>
                        <h5>Um welchen Energieliefervertrag handelt es sich?</h5>
                        <Row className="mt-4">
                            <Col xs="12">
                                    <Form.Check onChange={e => setSelectedElvs(e.target.checked)} 
                                        value={undefined} 
                                        id="allElvs" 
                                        type="checkbox" 
                                        label="Energieliefervertrag ist nicht relevant" 
                                    />
                            </Col>
                        </Row>
                        <Row className="mt-5" hidden={selectedElvs === null || selectedElvs.length === 0}>
                            <Col xs="12" className="text-center">
                                <p>Ausgewählte Energielieferverträge</p>
                                {selectedElvs !== null && selectedElvs !== false && selectedElvs !== true ?
                                    selectedElvs.map(selElv => (
                                        <Badge onClick={() => removeSelectedElvHandler(selElv.id)} 
                                            key={selElv.id} 
                                            id={selElv.id} 
                                            onMouseEnter={() => setSelectedElvsHover(true)} 
                                            onMouseLeave={() => setSelectedElvsHover(false)} 
                                            bg="energo" 
                                            className="animate-slide-left" 
                                            style={{marginRight: "5px", cursor: "pointer"}}
                                        >
                                            {selElv.id} {selectedElvsHover? "x": null}
                                        </Badge>
                                    ))
                                :null}
                            </Col>
                        </Row>
                        <Row className="mt-5 align-items-center">
                            <Col xs="12" xl="8">
                                <Form.Control 
                                    onChange={e => setElvsSearchField(e.target.value)} 
                                    value={elvSearchField} 
                                    disabled={selectedElvs===true} 
                                    placeholder="Anlagennummer Energielieferant" 
                                />
                            </Col>
                            <Col xs="3" xl="2">
                                <Form.Check 
                                    type="checkbox" 
                                    label="Aktive" 
                                    onChange={e => setElvActiveCheck(e.target.checked)} 
                                    defaultChecked={elvActiveCheck} 
                                    disabled={selectedElvs===true} 
                                />
                            </Col>
                            <Col xs="3" xl="2">
                                <Form.Check 
                                    type="checkbox" 
                                    label="Leerstand" 
                                    onChange={e => setElvLeerstandCheck(e.target.checked)} 
                                    defaultChecked={elvLeerstandCheck} 
                                    disabled={selectedElvs===true} 
                                />
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col xs="12">
                                <DataTable 
                                    onRowClicked={row => rowClickedHandler(row)} 
                                    data={filteredElvs} 
                                    columns={elvsTableColumns} 
                                    disabled={selectedElvs===true} 
                                    conditionalRowStyles={conditionalRowStyles}
                                    paginationComponentOptions={paginationOptions}
                                    pagination dense pointerOnHover
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs="12" className="text-end">
                                <Button
                                    onClick={() => props.setStage('buildings')} 
                                    variant="warning"
                                    style={{marginRight: "5px"}}
                                >Zurück
                                </Button>
                                <Button 
                                    onClick={() => {props.setSelectedElvs(selectedElvs); props.setStage('body')}} 
                                    hidden={selectedElvs === false || selectedElvs === null} 
                                    className="btn-energo"
                                    >Weiter
                                </Button>
                            </Col>
                        </Row>
                    </>
            }
        </>
    )
}

export default ElvTicketStage;